import { render, staticRenderFns } from "./row2.vue?vue&type=template&id=08616e3c&scoped=true&"
import script from "./row2.vue?vue&type=script&lang=js&"
export * from "./row2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08616e3c",
  null
  
)

export default component.exports